/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
export var ActivationRequestStatus;
(function (ActivationRequestStatus) {
    ActivationRequestStatus["EXPIRED"] = "EXPIRED";
    ActivationRequestStatus["ISSUED"] = "ISSUED";
    ActivationRequestStatus["WAITING"] = "WAITING";
})(ActivationRequestStatus || (ActivationRequestStatus = {}));
export var SchoolRelationRole;
(function (SchoolRelationRole) {
    SchoolRelationRole["GUARDIAN"] = "GUARDIAN";
    SchoolRelationRole["TEACHER"] = "TEACHER";
    SchoolRelationRole["STUDENT"] = "STUDENT";
    SchoolRelationRole["ADMIN"] = "ADMIN";
})(SchoolRelationRole || (SchoolRelationRole = {}));
export var IdpSamlCertificateUse;
(function (IdpSamlCertificateUse) {
    IdpSamlCertificateUse["ANY"] = "ANY";
    IdpSamlCertificateUse["ENCRYPTION"] = "ENCRYPTION";
    IdpSamlCertificateUse["SIGNATURE"] = "SIGNATURE";
})(IdpSamlCertificateUse || (IdpSamlCertificateUse = {}));
export var EmailUse;
(function (EmailUse) {
    EmailUse["PRIVATE"] = "PRIVATE";
    EmailUse["PROFESSIONAL"] = "PROFESSIONAL";
    EmailUse["SKOLID_INTERNAL"] = "SKOLID_INTERNAL";
})(EmailUse || (EmailUse = {}));
export var GroupMemberRole;
(function (GroupMemberRole) {
    GroupMemberRole["ADMIN"] = "ADMIN";
    GroupMemberRole["ISSUER"] = "ISSUER";
    GroupMemberRole["USER"] = "USER";
})(GroupMemberRole || (GroupMemberRole = {}));
export var UserRelationRole;
(function (UserRelationRole) {
    UserRelationRole["PARENT"] = "PARENT";
    UserRelationRole["CHILD"] = "CHILD";
    UserRelationRole["GENERIC"] = "GENERIC";
    UserRelationRole["PARTNER"] = "PARTNER";
})(UserRelationRole || (UserRelationRole = {}));
export var EmailInputErrorCode;
(function (EmailInputErrorCode) {
    EmailInputErrorCode["INVALID_INPUT"] = "INVALID_INPUT";
    EmailInputErrorCode["ALREADY_TAKEN"] = "ALREADY_TAKEN";
})(EmailInputErrorCode || (EmailInputErrorCode = {}));
export var CreateIdpErrorCode;
(function (CreateIdpErrorCode) {
    CreateIdpErrorCode["CONFLICT"] = "CONFLICT";
})(CreateIdpErrorCode || (CreateIdpErrorCode = {}));
export var CreateIdpFromMetadataErrorCode;
(function (CreateIdpFromMetadataErrorCode) {
    CreateIdpFromMetadataErrorCode["METADATA_ERROR"] = "METADATA_ERROR";
    CreateIdpFromMetadataErrorCode["CONFLICT"] = "CONFLICT";
})(CreateIdpFromMetadataErrorCode || (CreateIdpFromMetadataErrorCode = {}));
export var strippers = {
    AddEmailsInput: function (inp) {
        var obj = {};
        obj.emails = inp.emails.map(function (v) { return strippers.EmailInput(v); });
        obj.silent = inp.silent;
        obj.userId = inp.userId;
        return obj;
    },
    EmailInput: function (inp) {
        var obj = {};
        obj.confirmed = inp.confirmed;
        obj.use = inp.use;
        obj.value = inp.value;
        return obj;
    },
    AddRelationsInput: function (inp) {
        var obj = {};
        obj.toUsers = inp.toUsers.map(function (v) { return strippers.RelationInput(v); });
        obj.userId = inp.userId;
        return obj;
    },
    RelationInput: function (inp) {
        var obj = {};
        obj.role = inp.role;
        obj.userId = inp.userId;
        return obj;
    },
    CreateIdpInput: function (inp) {
        var obj = {};
        obj.claimMappings = inp.claimMappings ? inp.claimMappings.map(function (v) { return v ? strippers.IdpClaimMappingInput(v) : v; }) : undefined;
        obj.id = inp.id;
        obj.name = inp.name;
        obj.organizationId = inp.organizationId;
        obj.roles = inp.roles;
        obj.samlConfig = inp.samlConfig ? strippers.IdpSamlConfigInput(inp.samlConfig) : inp.samlConfig;
        return obj;
    },
    IdpClaimMappingInput: function (inp) {
        var obj = {};
        obj.set = inp.set ? strippers.SetIdpClaimMappingInput(inp.set) : inp.set;
        obj.transfer = inp.transfer ? strippers.TransferIdpClaimMappingInput(inp.transfer) : inp.transfer;
        return obj;
    },
    SetIdpClaimMappingInput: function (inp) {
        var obj = {};
        obj.target = inp.target;
        obj.value = inp.value;
        return obj;
    },
    TransferIdpClaimMappingInput: function (inp) {
        var obj = {};
        obj.matchRegex = inp.matchRegex;
        obj.source = inp.source;
        obj.target = inp.target;
        obj.targetValueSubstitution = inp.targetValueSubstitution;
        return obj;
    },
    IdpSamlConfigInput: function (inp) {
        var obj = {};
        obj.certificates = inp.certificates ? inp.certificates.map(function (v) { return v ? strippers.IdpSamlCertificateInput(v) : v; }) : undefined;
        obj.entityId = inp.entityId;
        obj.localSigningCertificateThumbprintHint = inp.localSigningCertificateThumbprintHint;
        obj.signAuthnRequest = inp.signAuthnRequest;
        obj.signLogoutRequest = inp.signLogoutRequest;
        obj.singleLogoutServiceBinding = inp.singleLogoutServiceBinding;
        obj.singleLogoutServiceUrl = inp.singleLogoutServiceUrl;
        obj.singleSignOnServiceBinding = inp.singleSignOnServiceBinding;
        obj.singleSignOnServiceUrl = inp.singleSignOnServiceUrl;
        return obj;
    },
    IdpSamlCertificateInput: function (inp) {
        var obj = {};
        obj.data = inp.data;
        return obj;
    },
    CreateIdpFromMetadataInput: function (inp) {
        var obj = {};
        obj.id = inp.id;
        obj.metadata = inp.metadata;
        obj.name = inp.name;
        obj.organizationId = inp.organizationId;
        obj.roles = inp.roles;
        return obj;
    },
    CreateUsersInput: function (inp) {
        var obj = {};
        obj.organizationId = inp.organizationId;
        obj.users = inp.users.map(function (v) { return strippers.UserInput(v); });
        return obj;
    },
    UserInput: function (inp) {
        var obj = {};
        obj.emails = inp.emails ? inp.emails.map(function (v) { return strippers.EmailInput(v); }) : undefined;
        obj.firstName = inp.firstName;
        obj.lastName = inp.lastName;
        obj.relations = inp.relations ? inp.relations.map(function (v) { return strippers.RelationInput(v); }) : undefined;
        return obj;
    },
    GenerateOnboardingTokenInput: function (inp) {
        var obj = {};
        obj.email = inp.email;
        obj.userId = inp.userId;
        return obj;
    },
    RemoveEmailsInput: function (inp) {
        var obj = {};
        obj.emails = inp.emails;
        obj.userId = inp.userId;
        return obj;
    },
    RemoveRelationsInput: function (inp) {
        var obj = {};
        obj.toUserIds = inp.toUserIds;
        obj.userId = inp.userId;
        return obj;
    },
    UpdateIdpInput: function (inp) {
        var obj = {};
        obj.claimMappings = inp.claimMappings ? inp.claimMappings.map(function (v) { return v ? strippers.IdpClaimMappingInput(v) : v; }) : undefined;
        obj.id = inp.id;
        obj.name = inp.name;
        obj.organizationId = inp.organizationId;
        obj.roles = inp.roles;
        obj.samlConfig = inp.samlConfig ? strippers.IdpSamlConfigInput(inp.samlConfig) : inp.samlConfig;
        return obj;
    },
    UpdateIdpFromMetadataInput: function (inp) {
        var obj = {};
        obj.id = inp.id;
        obj.metadata = inp.metadata;
        return obj;
    },
};
//# sourceMappingURL=admin-gql-2.js.map